import {
  GET_PERMISSIONCATEGORY,
  GET_PERMISSIONCATEGORY_SUCCESS,
  GET_PERMISSIONCATEGORY_FAIL,
  DELETE_PERMISSIONCATEGORY,
  DELETE_PERMISSIONCATEGORY_SUCCESS,
  DELETE_PERMISSIONCATEGORY_FAIL,
  UPDATE_PERMISSIONCATEGORY,
  UPDATE_PERMISSIONCATEGORY_SUCCESS,
  UPDATE_PERMISSIONCATEGORY_FAIL,
  ADD_NEW_PERMISSIONCATEGORY,
  ADD_PERMISSIONCATEGORY_SUCCESS,
  ADD_PERMISSIONCATEGORY_FAIL,
  PERMISSIONCATEGORY_LOADING,
  PERMISSIONCATEGORY_RESET
} from "./actionType";

export const resetPermissionCategoryState = (actionType) => ({
  type: PERMISSIONCATEGORY_RESET,
  payload: { actionType },
});

export const getPermissionCategorySuccess = (actionType, data) => ({
  type: GET_PERMISSIONCATEGORY_SUCCESS,
  payload: { actionType, data },
});

export const getPermissionCategoryFail = (actionType, error) => ({
  type: GET_PERMISSIONCATEGORY_FAIL,
  payload: { actionType, error },
});

export const getPermissionCategory = data => ({
  type: GET_PERMISSIONCATEGORY,
  payload: data,
});

export const getPermissionCategoryLoading = () => ({
  type: PERMISSIONCATEGORY_LOADING
});

export const deletePermissionCategory = data => ({
  type: DELETE_PERMISSIONCATEGORY,
  payload: data,
});

export const deletePermissionCategorySuccess = data => ({
  type: DELETE_PERMISSIONCATEGORY_SUCCESS,
  payload: data,
});

export const deletePermissionCategoryFail = error => ({
  type: DELETE_PERMISSIONCATEGORY_FAIL,
  payload: error,
});

export const updatePermissionCategory = data => ({
  type: UPDATE_PERMISSIONCATEGORY,
  payload: data,
});

export const updatePermissionCategoryFail = error => ({
  type: UPDATE_PERMISSIONCATEGORY_FAIL,
  payload: error,
});

export const updatePermissionCategorySuccess = data => ({
  type: UPDATE_PERMISSIONCATEGORY_SUCCESS,
  payload: data,
});

export const addNewPermissionCategory = data => ({
  type: ADD_NEW_PERMISSIONCATEGORY,
  payload: data,
});

export const addPermissionCategorySuccess = data => ({
  type: ADD_PERMISSIONCATEGORY_SUCCESS,
  payload: data,
});

export const addPermissionCategoryFail = error => ({
  type: ADD_PERMISSIONCATEGORY_FAIL,
  payload: error,
});